/**
 * Presentation
 *
 * @author Creator-Solutions -> Owen Burns
 */
import { FC } from "react";

import { FeedCard } from "@/components";
import { FeedPresentationContainer } from "../styling/feedPage.styles";
import { GetFeedInterface, GetFeedState } from "@/interfaces/services/feed";

interface Props {
  feed: Array<GetFeedState>;
}

const FeedPresentation: FC<Props> = (props) => {
  return (
    <FeedPresentationContainer>
      {props.feed.map((item, index) => {
        return (
          <FeedCard
            key={index}
            FeedID={item.FeedID}
            FeedAuthor={item.FeedAuthor}
            FeedDate={item.FeedDate}
            FeedContent={item.FeedContent}
            FeedTags={item.FeedTags}
            FeedImage={item.FeedImage}
            FeedLikes={item.FeedLikes}
            FeedTitle={item.FeedTitle}
            Pinned={item.Pinned}
          />
        );
      })}
    </FeedPresentationContainer>
  );
};

export default FeedPresentation;
